import PodcastPageConfig from "pages/podcast/config";
import { DataType, PodcastConfig } from "components/podcast/PodcastProvider";
import htmlToJson from "html-to-json";
import { PodcastMarkdownConfig, parseMarkdown } from "./formatters";

interface GetCidContentProps {
  CID: string;
  type?: DataType;
}

interface GetCidContentReturn {
  contentArray?: string[];
  isMp3File?: boolean;
  thumbnailLink?: string;
}

export interface GetPodcastData {
  episodeNumber: number;
  episodeContent: string;
}

export const getCidContent = async ({ CID, type }: GetCidContentProps): Promise<GetCidContentReturn> => {
  const contentLink = `https://${CID}${PodcastPageConfig.ipfsGatewayUrl}/${type === DataType.Thumbnail ? "" : "chunks"}`;
  const response = await fetch(contentLink);
  const responseHtml = await response.text();

  const result = await htmlToJson.batch(responseHtml, {
    files: htmlToJson.createParser([
      ".ipfs-hash",
      {
        file: function ($section: any) {
          if ($section.attr("href")) {
            return $section.attr("href").split("/")[2];
          } else {
            return "";
          }
        }
      }
    ])
  });

  const files = await result.files;
  const contentArray: string[] = [];

  const removeFileName = (files: { file: string }[]) => {
    for (const indexfile of files) {
      if (indexfile.file) {
        contentArray.push(`${indexfile.file.split("?")[0]}`);
      }
    }
  };

  if (files && files[1]) {
    switch (type) {
      case DataType.Content:
        if (files[1].file.indexOf(".mp3") == files[1].file.length - 4) {
          removeFileName(files);
          return { isMp3File: true, contentArray };
        } else {
          removeFileName(files);
          return { isMp3File: false, contentArray };
        }
      case DataType.Thumbnail:
        return {
          thumbnailLink: `https://${files[1].file.split("?")[0]}${PodcastPageConfig.ipfsGatewayUrl}`
        };
    }
  }
  return {};
};

export const getPodcastData = async ({ episodeNumber, episodeContent }: GetPodcastData) => {
  const result: PodcastMarkdownConfig = parseMarkdown(episodeContent);
  const podcastConfigData: PodcastConfig = { ...result };
  try {
    const cidResponse = await fetch(`https://${result.CID}${PodcastPageConfig.ipfsGatewayUrl}/index.json`);
    const cidResult = await cidResponse.json();
    if (result && cidResult) {
      podcastConfigData["episode_number"] = episodeNumber;
      podcastConfigData["thumbnail_url"] = (await getCidContent({ CID: cidResult.thumbnailCID, type: DataType.Thumbnail }))?.thumbnailLink;
      const contentResult = await getCidContent({ CID: cidResult.contentCID, type: DataType.Content });
      if (contentResult?.isMp3File) {
        podcastConfigData["audio_urls"] = contentResult?.contentArray;
      } else {
        podcastConfigData["video_urls"] = contentResult?.contentArray;
      }
    }
    return podcastConfigData;
  } catch {
    return podcastConfigData;
  }
};
